import React from "react";

import { getEmployeeFormId } from "EmployeeDashboard/selectors";
import { tryGetAccountById, tryGetCompanyPolicyById, tryGetCompanyProfileById, tryGetEmployeePolicyById, tryGetEmployeeFormById } from "EntitiesApi/Selectors";
import { BrokerFormFooter } from "Features/BrokerForm";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { Card } from "Common/Card";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import ThemeInstaller from "Common/ThemeInstaller";

import DashboardTopBar from "./DashboardTopBar";

type Props = {
  children: React.ReactNode;
  variant?: "single" | "multi";
  title?: string;
};

const Chrome = ({ variant = "single", title = "SimplyInsured", ...rest }: Props) => {
  const account = useSelector((state) => tryGetAccountById(state, state.accountId));
  const employeePolicyId = account?.enrolledEmployeePolicy || account?.upcomingEmployeePolicy;
  const employeePolicy = useSelector((state) => tryGetEmployeePolicyById(state, employeePolicyId));
  const fallbackEmployeeFormId = useSelector(getEmployeeFormId);
  const employeeFormId = employeePolicy?.employeeForm || fallbackEmployeeFormId;
  const employeeForm = useSelector((state) => tryGetEmployeeFormById(state, employeeFormId));

  const companyPolicyId = account?.enrolledCompanyPolicy || account?.upcomingCompanyPolicy;
  const companyPolicy = useSelector((state) => tryGetCompanyPolicyById(state, companyPolicyId));
  const companyProfile = useSelector((state) => tryGetCompanyProfileById(state, companyPolicy?.companyProfile));

  const isBenefitsAdmin = companyProfile?.benefitsAdmin || employeeForm?.benefitsAdmin;
  const props = variant === "single" ? { componentClass: Card, mt: 5 } : {};
  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <DashboardTopBar />
      <Div className="min-h-dvh">
        <Grid {...props} {...rest} />
      </Div>
      {account && (isBenefitsAdmin ? <BrokerFormFooter showSISupportLinks={account?.hasCompanyAccess} /> : <Footer />)}
      <Heartbeat />
      <ThemeInstaller />
    </div>
  );
};

export default Chrome;
